export const kContainerClass = "codap-container"
// scrollable document content that bounds drags
export const kDragContainerClass = "drag-container"
